// extracted by mini-css-extract-plugin
module.exports = {"mt_02":"licentieaanbod_mt_02__2xLbm","modal_footer":"licentieaanbod_modal_footer__2iMT4"};